module.exports = __webpack_public_path__ + "static/media/1J.790ac87f.svg";